export const LICENSED_CLINICIAN = { id: 1000, name: 'Licensed' };
export const SUPERVISED_CLINICIAN = { id: 1000, name: 'Supervised' };
export const SELF_PAY_LABEL = 'Self-pay (out of pocket)';
export const SELF_PAY_VALUE = 'self_pay';
